<template>
    <div ref="chartContainer" style="width: 100%; height: 400px;"></div>
</template>
<script>
import * as echarts from 'echarts';
export default {
    name: "StackedColumnChartComponent",
    props: {
        data: {
            type: Array,
            required: true
        },
        timeLineRange: {
            type: Array,
            required: true
        },
        color: {
            type: Array,
            required: false,
            default: () => ['#2ec7c9','#b6a2de','#5ab1ef','#ffb980','#d87a80']
        },
        onlyInteger: {
            type: Boolean,
            required: false,
            default: false
        },
        measurement: {
            type: String,
            required: false,
            default: null
        }
    },
    methods: {
        setupChart() {
            const legendData = this.data.map(item => item.name);
            const seriesData = this.data.map((item, index) => {
                return {
                        name: item.name,
                        type: 'bar',
                        data: item.data,
                        stack: 'Default',
                        itemStyle: {
                            normal: {
                                label: {
                                    show: false,
                                    position: 'top',
                                    textStyle: {
                                        fontWeight: 500
                                    }
                                }
                            }
                        },
                    }
                });

            const chartElement = this.$refs.chartContainer;

            let chart = echarts.getInstanceByDom(chartElement);

            if (!chart) {
                chart = echarts.init(chartElement);
            }

            // Configure chart options
            const options = {
                // Define colors
                color: this.color,

                // Global text styles
                textStyle: {
                    fontFamily: 'Roboto, Arial, Verdana, sans-serif',
                    fontSize: 13
                },

                // Chart animation duration
                animationDuration: 750,

                // Setup grid
                grid: {
                    left: 0,
                    right: 10,
                    top: 35,
                    bottom: 0,
                    containLabel: true
                },

                // Add legend
                legend: {
                    data: legendData,
                    itemHeight: 8,
                    itemGap: 20
                },

                // Add tooltip
                tooltip: {
                    trigger: 'axis',
                    backgroundColor: 'rgba(0,0,0,0.75)',
                    padding: [10, 15],
                    textStyle: {
                        fontSize: 13,
                        fontFamily: 'Roboto, sans-serif',
                        color: '#fff'
                    },
                    formatter: (params) => {
                        let tooltip = params[0].name + '<br />';
                        let total = 0;

                        params.forEach(param => {
                             const val = Number(param.value || 0);
                             total += val;
                             const value = val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ");
                             tooltip += `<div style="display: flex; justify-content: space-between; align-items: center;">
                                <span>${param.marker} ${param.seriesName}</span>
                                <span style="font-weight: bold; margin-left: 15px">${value}${this.measurement ? ' ' + this.measurement : ''}</span>
                            </div>`;
                        });

                        if (params.length > 1) {
                            const totalValue = Number(total.toFixed(2)).toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ");
                            tooltip += `<div style="border-top: 1px solid rgba(255,255,255,0.3); margin-top: 5px; padding-top: 5px; display: flex; justify-content: space-between; align-items: center;">
                                <span>${this.$t('labels.total')}</span>
                                <span style="font-weight: bold; margin-left: 15px">${totalValue}${this.measurement ? ' ' + this.measurement : ''}</span>
                            </div>`;
                        }

                        return tooltip;
                    },
                    axisPointer: {
                        type: 'shadow',
                        shadowStyle: {
                            color: 'rgba(0,0,0,0.025)'
                        }
                    },
                    borderColor: 'rgba(0,0,0,0)'
                },

                // Horizontal axis
                xAxis: [{
                    type: 'category',
                    data: [...this.timeLineRange],
                    axisLabel: {
                        color: '#333'
                    },
                    axisLine: {
                        lineStyle: {
                            color: '#999'
                        }
                    },
                    splitLine: {
                        show: true,
                        lineStyle: {
                            color: '#eee',
                            type: 'dashed'
                        }
                    }
                }],

                // Vertical axis
                yAxis: [{
                    type: 'value',
                    minInterval: this.onlyInteger ? 1 : undefined,
                    axisLabel: {
                        color: '#333',
                        formatter: value => {
                            return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ");
                        }
                    },
                    axisLine: {
                        lineStyle: {
                            color: '#999'
                        }
                    },
                    splitLine: {
                        lineStyle: {
                            color: '#eee'
                        }
                    },
                    splitArea: {
                        show: true,
                        areaStyle: {
                            color: ['rgba(250,250,250,0.1)', 'rgba(0,0,0,0.01)']
                        }
                    }
                }],

                // Add series
                series: seriesData
            };

            // Set chart options
            chart.setOption(options, true);
        }
    },
    watch: {
        data: {
            handler() {
                this.$nextTick(() => {
                    this.setupChart();
                });
            },
            immediate: true
        }
    }
}
</script>